var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 302,
    viewBox: "0 0 310 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.644 -18.5601L163.256 35.8908C159.353 38.7099 159.718 45.3579 163.928 48.1677L176.254 56.3904C179.371 58.4713 180.553 62.8999 178.895 66.2924L146.87 131.817C145.21 135.212 141.332 136.28 138.208 134.203L66.4759 86.5172C63.3519 84.4405 59.4721 85.509 57.8131 88.9071L-28.0515 263.9C-29.7111 267.296 -28.523 271.731 -25.399 273.808L0.823066 291.239C3.94703 293.316 7.82463 292.248 9.48425 288.852L75.4295 154.67C77.0892 151.274 80.9668 150.206 84.0907 152.283L155.797 199.951C158.921 202.028 162.799 200.96 164.459 197.564L216.384 91.3347C218.045 87.9359 221.93 86.869 225.056 88.9533L238.349 97.8235C242.59 100.653 247.719 97.5872 247.769 92.1931L248.733 -11.9131C248.788 -17.7705 242.91 -21.6408 238.643 -18.557L238.644 -18.5601Z",
    fill: "#FDF1DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallArrow);
export default __webpack_public_path__ + "static/media/install_arrow.8ac4868e95fecb61003c33d0a363bf5e.svg";
export { ForwardRef as ReactComponent };